/**
 * components util
 */

/**
 * 清理空值，对象
 * @param children
 * @returns {*[]}
 */
export function filterEmpty() {
  var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return children.filter(function (c) {
    return c.tag || c.text && c.text.trim() !== '';
  });
} // 转换星期

export function changeWeek(week) {
  var result = "";

  switch (week) {
    case 1:
      result = "星期一";
      break;

    case 2:
      result = "星期二";
      break;

    case 3:
      result = "星期三";
      break;

    case 4:
      result = "星期四";
      break;

    case 5:
      result = "星期五";
      break;

    case 6:
      result = "星期六";
      break;

    case 7:
      result = "星期日";
      break;
  }

  return result;
}